import CustomerSidebar from "./CustomerSidebar.tsx";
export default function CustomerPanelLayout(prop) {
  return (
    <div className="d-flex pt-5" style={{ backgroundColor: "#DBF0EE" }}>
      <CustomerSidebar></CustomerSidebar>
      {prop.children}{" "}
    </div>
  );
}
